/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Permissions_Remove_Toast_Success_DescriptionInputs */

const es_components_credentials_permissions_remove_toast_success_description = /** @type {(inputs: Components_Credentials_Permissions_Remove_Toast_Success_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El usuario ya no tiene acceso a esta credencial.`)
};

const en_components_credentials_permissions_remove_toast_success_description = /** @type {(inputs: Components_Credentials_Permissions_Remove_Toast_Success_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The user no longer has access to this credential.`)
};

/**
* | output |
* | --- |
* | "The user no longer has access to this credential." |
*
* @param {Components_Credentials_Permissions_Remove_Toast_Success_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_permissions_remove_toast_success_description = /** @type {((inputs?: Components_Credentials_Permissions_Remove_Toast_Success_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Permissions_Remove_Toast_Success_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_permissions_remove_toast_success_description(inputs)
	return en_components_credentials_permissions_remove_toast_success_description(inputs)
});
export { components_credentials_permissions_remove_toast_success_description as "components.credentials.permissions.remove.toast.success.description" }